/* unplugin-vue-components disabled */import { render } from "./VideoDetails.vue?vue&type=template&id=72de6ad4&scoped=true"
import script from "./VideoDetails.vue?vue&type=script&lang=js"
export * from "./VideoDetails.vue?vue&type=script&lang=js"

import "./VideoDetails.vue?vue&type=style&index=0&id=72de6ad4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72de6ad4"]])

export default __exports__